export default __webpack_public_path__ + "static/media/session6.25c1aece.svg";